import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import {
  getIsOpen,
  getHeader,
  getFileName,
  getOutcome,
  handleUpload,
  handleChangeOutcome,
  updateIsOpen
} from "containers/Upload/reducer";

import Upload from "components/Upload/Upload";

class UploadContainer extends React.PureComponent {
  render() {
    return <Upload {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch) => ({
  updateIsOpen: (isOpen) => dispatch(updateIsOpen(isOpen)),
  handleUpload: () => dispatch(handleUpload()),
  handleChangeOutcome: (val) => dispatch(handleChangeOutcome(val))
});

const mapStateToProps = (state) => ({
  isOpen: getIsOpen(state),
  header: getHeader(state),
  fileName: getFileName(state),
  outcome: getOutcome(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(UploadContainer);
